import React, { useEffect, useState } from "react";
import { PageLayout } from "../components/page-layout";
import { getAuctionListResource } from "../services/auction.service";
import { AuctionHelper } from "../components/auction/auction-helper";
import { Skeleton, Box, Typography, Stack } from '@mui/material';

export const AuctionHelperPage = () => {
  const [auctionPlayers, setAuctionPlayers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const getAuctionList = async () => {
      setIsLoading(true);
      const { data, error } = await getAuctionListResource();
      if (!isMounted) {
        return;
      }

      if (data) {
        setAuctionPlayers(data);
      }
      setIsLoading(false);

      if (error) {
        setError(error);
      }
    };

    getAuctionList();

    return () => {
      isMounted = false;
    };
  }, []);

  if (error) {
    return (
      <PageLayout>
        <div className="content-layout">
          <div className="content__body">
            <Typography color="error">Error loading auction data: {error.message}</Typography>
          </div>
        </div>
      </PageLayout>
    );
  }

  return (
    <PageLayout>
      <div className="content-layout">
        <div className="content__body">
          {isLoading ? (
            <Box sx={{ p: 2 }}>
              <Stack spacing={1}>
                <Skeleton variant="rounded" width="100%" height={100} />
                <Skeleton variant="rounded" width="100%" height={48} />
                <Skeleton variant="rounded" width="100%" height={300} />
              </Stack>
            </Box>
          ) : auctionPlayers.length > 0 ? (
            <AuctionHelper players={auctionPlayers} />
          ) : (
            <Typography sx={{ textAlign: 'center', py: 4 }}>No auction players found.</Typography>
          )}
        </div>
      </div>
    </PageLayout>
  );
};
